import { render, staticRenderFns } from "./MyAccountInsights.vue?vue&type=template&id=c01ffdd4&scoped=true&"
import script from "./MyAccountInsights.vue?vue&type=script&lang=js&"
export * from "./MyAccountInsights.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountInsights.vue?vue&type=style&index=0&id=c01ffdd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01ffdd4",
  null
  
)

export default component.exports